<div class="tab-container">
    <div class="sensor-container" *ngFor="let sensor of model.counterSensors; let i = index">
        <div class="sensor-row">
            <div class="input-group">
                <label class="flex-center">{{ i + 1 | number:'2.0-0' }}</label>
                <div class="icon-button" [ngClass]="{ 'disabled': isFixedSensor(sensor) }">
                    <i class="juc ju-delete" (click)="onRemoveSensorBtnClicked(i)"></i>
                </div>
            </div>

            <div class="input-group col2">
                <label [for]="'meterType' + i">Zählerart*</label>
                <select [name]="'meterType' + i" [id]="'meterType' + i" required
                        [ngClass]="{ 'no-value': sensor.meterType === undefined }"
                        (ngModelChange)="onMeterTypeChanged(sensor, $event)"
                        [ngModel]="sensor.meterType" [disabled]="isFixedSensor(sensor)" #dynamicInput="ngModel">
                    <option [ngValue]="undefined" disabled>Bitte auswählen</option>
                    <option *ngFor="let option of meterTypeOptions" [ngValue]="option.value">
                        {{ option.label }}
                    </option>
                </select>
            </div>

            <app-input-image-upload [id]="'counterSensorPhoto' + i"
                                    [name]="'counterSensorPhoto' + i"
                                    required
                                    [imageQuality]="LOW_IMAGE_QUALITY"
                                    [label]="sensor?.name ? sensor.name : 'Zähler'"
                                    [(ngModel)]="sensor.image"
                                    #dynamicInput="ngModel">
            </app-input-image-upload>

        </div>
        <div class="sensor-params" *ngIf="sensor.meterType">
            <div class="input-row">
                <div class="input-group">
                    <label [for]="'module' + i">Modul*</label>
                    <select [name]="'module' + i" [id]="'module' + i" required
                            [ngClass]="{ 'no-value': sensor.module === undefined }"
                            [(ngModel)]="sensor.module" [disabled]="isFixedSensor(sensor)" #dynamicInput="ngModel">
                        <ng-container *ngIf="isFixedSensor(sensor)">
                            <option [ngValue]="sensor.module">
                                {{ sensor.module }}
                            </option>
                        </ng-container>
                        <ng-container *ngIf="!isFixedSensor(sensor)">
                            <option [ngValue]="undefined" disabled>Bitte auswählen</option>
                            <ng-container *ngFor="let option of moduleOptions">
                                <option
                                        *ngIf="sensor.meterType === MeterTypeEnum.Impulse || ((option.moduleType === 'SM02' || option.moduleType === 'SM03' || option.moduleType === 'SM04' || option.moduleType === 'SM05') && sensor.meterType === MeterTypeEnum.IR)"
                                        [ngValue]="option.value">
                                    {{ option.label }}
                                </option>
                            </ng-container>
                        </ng-container>
                    </select>
                </div>
                <div class="input-group">
                    <label [for]="'id' + i">ID*</label>
                    <select [name]="'id' + i" [id]="'id' + i" required
                            [ngClass]="{ 'no-value': sensor.sensorId === undefined }"
                            [(ngModel)]="sensor.sensorId" [disabled]="isFixedSensor(sensor)" #dynamicInput="ngModel">
                        <option [ngValue]="undefined" disabled>Bitte auswählen</option>
                        <ng-container *ngFor="let option of getIdOptions(sensor.module, sensor.sensorId)">
                            <option *ngIf="!option.disabled || option.value === sensor.sensorId"
                                    [ngValue]="option.value">
                                {{ option.label }}
                            </option>
                        </ng-container>
                    </select>
                </div>
            </div>
            <div class="input-group">
                <label [for]="'sensorName' + i">Sensorname*</label>
                <select [name]="'sensorName' + i" [id]="'sensorName' + i" required
                        [ngClass]="{ 'no-value': sensor.name === undefined }"
                        [(ngModel)]="sensor.name" #dynamicInput="ngModel">
                    <option [ngValue]="undefined" disabled>Bitte auswählen</option>
                    <option *ngFor="let option of sensorNameOptions" [ngValue]="option.value">
                        {{ option.label }}
                    </option>
                </select>
                <div class="error">
                </div>
            </div>
            <div class="input-group" *ngIf="sensor.meterType === MeterTypeEnum.IR">
                <label [for]="'IRType' + i">IR Typ*</label>
                <select [name]="'IRType' + i" [id]="'IRType' + i" required
                        [ngClass]="{ 'no-value': sensor.irType === undefined }"
                        [(ngModel)]="sensor.irType" [disabled]="isFixedSensor(sensor)" #dynamicInput="ngModel">
                    <ng-container *ngIf="isFixedSensor(sensor)">
                        <option [ngValue]="sensor.irType">
                            {{ sensor.irType }}
                        </option>
                    </ng-container>
                    <ng-container *ngIf="!isFixedSensor(sensor)">
                        <option [ngValue]="undefined" disabled>Bitte auswählen</option>
                        <option *ngFor="let option of irTypeOptions" [ngValue]="option">
                            {{ option }}
                        </option>
                    </ng-container>
                </select>
                <div class="error">
                </div>
            </div>
            <div class="input-group">
                <label [for]="'seriesNumber' + i">Seriennummer*</label>
                <input
                        [name]="'seriesNumber' + i"
                        [id]="'seriesNumber' + i"
                        type="text"
                        required
                        [(ngModel)]="sensor.seriesNumber"
                        [disabled]="sensor.meterType === MeterTypeEnum.IR"
                        #seriesNumberModel="ngModel"
                        placeholder="Seriennummer eingeben"
                        #dynamicInput="ngModel"/>
                <div class="error">
                    <span *ngIf="showError(seriesNumberModel)">Seriennummer ist ein Pflichtfeld.</span>
                </div>
            </div>
            <div class="input-group">
                <label [for]="'manufacturer' + i">Hersteller*</label>
                <input [name]="'manufacturer' + i"
                       [id]="'manufacturer' + i"
                       type="text"
                       required
                       [(ngModel)]="sensor.manufacturer"
                       [disabled]="sensor.meterType === MeterTypeEnum.IR"
                       #manufacturerModel="ngModel"
                       placeholder="Hersteller eingeben"
                       #dynamicInput="ngModel"/>
                <div class="error">
                    <span *ngIf="showError(manufacturerModel)">Hersteller ist ein Pflichtfeld.</span>
                </div>
            </div>
        </div>
        <div class="sensor-params" *ngIf="sensor.meterType === MeterTypeEnum.IR">
            <div class="input-group">
                <label [for]="'value' + i">Ausgelesener Wert*</label>
                <input [name]="'value' + i"
                       [id]="'value' + i"
                       type="text"
                       required
                       [(ngModel)]="sensor.irType === 'sml' ? sensor.smlValue?.join(', ') : sensor.value"
                       disabled
                       #manufacturerModel="ngModel"
                       placeholder="Hersteller eingeben"
                       #dynamicInput="ngModel"/>
                <div class="error">
                </div>
            </div>
        </div>
        <div class="sensor-params" *ngIf="sensor.meterType === MeterTypeEnum.Impulse">
            <div class="input-group col2">
                <label [for]="'sensorStepInUnit' + i">Impuls pro Einheit*</label>
                <input
                        [name]="'sensorStepInUnit' + i"
                        [id]="'sensorStepInUnit' + i"
                        type="number"
                        pattern="^\d+(\.\d{1,3})?$|^$"
                        [(ngModel)]="sensor.impulse.stepInUnit"
                        #stepInUnit="ngModel"
                        placeholder="Impulse per Unit eingeben"
                        #dynamicInput="ngModel"
                        required/>
                <div class="error">
                    <span *ngIf="showError(stepInUnit) && !showImpulseError(stepInUnit)">Impuls pro Einheit muss eine positive reelle Zahl sein.</span>
                    <span *ngIf="showImpulseError(stepInUnit)">Impuls ist optional, aber wenn Sie es hinzufügen möchten, sind alle Felder erforderlich.</span>
                </div>
            </div>

            <div class="input-group col2">
                <label [for]="'sensorInitOffset' + i">Aktuell*</label>
                <input
                        [name]="'sensorInitOffset' + i"
                        [id]="'sensorInitOffset' + i"
                        type="number"
                        pattern="^\d+$|^$"
                        [(ngModel)]="sensor.impulse.initOffset"
                        #initOffset="ngModel"
                        placeholder="Aktuellen Impuls eingeben"
                        #dynamicInput="ngModel"
                        required/>
                <div class="error">
                    <span *ngIf="showError(initOffset)">Aktuell muss eine ganze positive Zahl sein.</span>
                    <span *ngIf="showImpulseError(initOffset)">Impuls ist optional, aber wenn Sie es hinzufügen möchten, sind alle Felder erforderlich.</span>
                </div>
            </div>
        </div>

        <div class="input-group">
            <label [for]="'customName'+i">Benutzerdefinierter Name</label>
            <input type="text"
                   [name]="'customName'+i"
                   [id]="'customName'+i"
                   [(ngModel)]="sensor.customName">
        </div>
    </div>

    <div class="button-container">
        <button
                class="secondary"
                type="button"
                (click)="onAddSensorBtnClicked()"
                [disabled]="model.counterSensors?.length > 15">
            <i class="ju ju-add"></i>
            Zähler hinzufügen
        </button>
    </div>

    <div class="button-container buttons" *ngIf="hasIRMeter()">
        <button
                class="primary"
                type="button"
                (click)="sendModuleConfig()"
                [disabled]="!IRMetersAreValid() || irButtonsDisabled"
        >
            Alle IR-Leseköpfe konfigurieren
        </button>
        <button
                class="primary"
                type="button"
                (click)="getMeasurementData()"
                [disabled]="!IRMetersAreValid() || waitingForIRMeasurement || irButtonsDisabled"
        >
            Alle IR-Leseköpfe abfragen
        </button>
    </div>
    <div class="timer" *ngIf=" waitingForIRMeasurement && !(timerForIRUpdate | async)">
        <span>Daten werden geladen</span>
        <span class="loading">
        <img src="../../../../../../../../../assets/images/icons/refresh.svg"/>
    </span>
    </div>
    <div class="timer" *ngIf="!!(timerForIRUpdate | async)">
        <span>Wartezeit bis zur nächsten Datenabfrage:</span>
        <div class="progress-bar">
        <span class="label">{{ (timerForIRUpdate | async).timer }}
            / {{ (timerForIRUpdate | async).totalSeconds }}</span>
            <div class="progress"
                 [style.width.%]="((timerForIRUpdate | async).timer / (timerForIRUpdate | async).totalSeconds) * 100"></div>
        </div>
    </div>
    <div class="timer" *ngIf="(timerForIRButtonsDisabled | async) !== null">
        <span>Bitte warten</span>
        <div class="progress-bar">
            <span class="label">{{ (timerForIRButtonsDisabled | async) }} / {{ irButtonsDisabledTime }}</span>
            <div class="progress"
                 [style.width.%]="((timerForIRButtonsDisabled | async) / irButtonsDisabledTime) * 100"></div>
        </div>
    </div>
</div>
<div class="field">Pflichtfelder*</div>
<app-navigation-footer
        [isBackLinkDisabled]="false"
        [backLink]="'/gateway/sensors/pump'"
        [isNextLinkDisabled]="!validationService.isSensorsCounterValid(model)"
        [nextLink]="'/gateway/sensors/control'"
        [isLast]="false"
></app-navigation-footer>
